<template lang="pug">
    Aside(:ativo="content !== null" @close="content = null").asideVideo
        video(:src="content", autoplay, controls, preload="metadata")
</template>

<script>
import { components } from '@/mixins/components'

export default {
    name: "component-aside-video",
    components,
    data() {
        return {
            content: null,
        }
    },
    mounted() {
        this.$eventbus.$on('asideOpenVideo', content => this.content = content)
    },
}
</script>

<style lang="stylus" scoped src="./AsideVideo.styl"></style>